import { Box, Typography } from '@mui/material';

function Banner() {
  // Only show banner if current hostname is 'uat.neuroelpis.com'
  if (typeof window !== 'undefined' && window.location.hostname !== 'uat.neuroelpis.com') {
    return null;
  }

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: 'error.main',
        color: 'common.white',
        textAlign: 'center',
        py: 0.5,
        fontWeight: 'medium',
        fontSize: '0.875rem', // equivalent to text-sm
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        ⚠️ You are in a test environment. Not intended for live use.
      </Typography>
    </Box>
  );
}

export default Banner;
